<template>
  <ValidationField
      :uuid="uuid"
      :propPath="propPath"
      :formRef="formRef"
      v-if="!$props.readOnly"
  >
    <template v-slot:default=" { error, deleteServerError }" >
      <v-radio-group
        v-model="internalModel"
        :label="$props.label"
        :error-messages="error"
        @change="deleteServerError"
        dense
      >
        <v-radio
          :label="$props.falseLabel"
          :value="false"
        />
        <v-radio
          :label="$props.trueLabel"
          :value="true"
        />
      </v-radio-group>
    </template>
  </ValidationField>
  <b-read-only-text-field
      v-else
      :label="$props.label"
      :value="currentSelectionText"
  />
</template>

<script>
import ValidationField from "@/components/base_components/ValidationField";

export default {
  name: "BRadio",
  components: { ValidationField },
  props: {
    value: [Boolean],
    label: String,
    trueLabel: { type: String, default: 'Ja' },
    falseLabel: { type: String, default: 'Nein' },
    uuid: String,
    propPath: String,
    formRef: String,
    readOnly: { type: Boolean, default: false },
  },
  data() {
    return {
      lazyValue: this.value
    }
  },
  computed: {
    internalModel: {
      get() {
        return this.lazyValue;
      },
      set(val) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    },
    currentSelectionText() {
      return this.value ? 'Ja' : 'Nein';
    }
  },
  watch: {
    value(val) {
      this.lazyValue = val;
    }
  }
}
</script>

<style scoped>

</style>
